import { render, staticRenderFns } from "./InspectionRecordStatistics.vue?vue&type=template&id=a072c3e8&scoped=true"
import script from "./InspectionRecordStatistics.vue?vue&type=script&lang=js"
export * from "./InspectionRecordStatistics.vue?vue&type=script&lang=js"
import style0 from "./InspectionRecordStatistics.vue?vue&type=style&index=0&id=a072c3e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a072c3e8",
  null
  
)

export default component.exports